(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-bundle"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const bundleItems = [];
  const addBundleBtn = document.getElementById('add-bundle-to-cart');
  
  // Initialize all product elements
  const productElements = document.querySelectorAll('[data-bundle-product="true"]');
  
  // Add event listeners to all "Add to Bundle" buttons
  document.querySelectorAll('.bundle-add-btn').forEach(button => {
    button.addEventListener('click', function() {
      const productId = this.dataset.productId;
      const productElement = this.closest('[data-bundle-product="true"]');
      const variantId = getSelectedVariantId(productElement);
      
      if (!variantId) {
        alert('Please select all options for this product');
        return;
      }
      
      const itemIndex = bundleItems.findIndex(item => item.id === productId);
      
      if (itemIndex > -1) {
        // Remove from bundle
        bundleItems.splice(itemIndex, 1);
        this.textContent = 'Add to Bundle';
        productElement.classList.remove('bundle-selected');
      } else if (bundleItems.length < 4) {
        // Add to bundle
        bundleItems.push({
          id: productId,
          variantId: variantId,
          quantity: 1,
          element: productElement
        });
        this.textContent = 'Remove from Bundle';
        productElement.classList.add('bundle-selected');
      }
      
      updateBundleUI();
    });
  });
  
  // Update variant selection when options change
  document.querySelectorAll('.bundle-variant-selector').forEach(select => {
    select.addEventListener('change', function() {
      const productElement = this.closest('[data-bundle-product="true"]');
      const productId = productElement.dataset.productId;
      const addButton = productElement.querySelector('.bundle-add-btn');
      
      // If product is in bundle, update its variant
      const bundleItem = bundleItems.find(item => item.id === productId);
      if (bundleItem) {
        const newVariantId = getSelectedVariantId(productElement);
        if (newVariantId) {
          bundleItem.variantId = newVariantId;
        } else {
          // If variant becomes invalid, remove from bundle
          const itemIndex = bundleItems.findIndex(item => item.id === productId);
          if (itemIndex > -1) {
            bundleItems.splice(itemIndex, 1);
            addButton.textContent = 'Add to Bundle';
            productElement.classList.remove('bundle-selected');
            updateBundleUI();
          }
        }
      }
    });
  });
  
  // Handle adding bundle to cart
  addBundleBtn.addEventListener('click', async function() {
    if (bundleItems.length !== 4 || this.disabled) return;
    
    const button = this;
    button.disabled = true;
    button.textContent = 'Adding...';
    
    try {
      // Add items sequentially
      for (const item of bundleItems) {
        await addItemToCart(item.variantId, item.quantity);
      }
      
      // Redirect to cart after all items are added
      window.location.href = '/cart';
    } catch (error) {
      console.error('Error adding bundle to cart:', error);
      alert('There was an error adding your bundle to cart. Please try again.');
      button.disabled = false;
      button.textContent = 'Add Bundle to Cart (50% Off)';
    }
  });
  
  // Helper function to add item to cart
  function addItemToCart(variantId, quantity) {
    return new Promise((resolve, reject) => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: {
            
            'Bundle Discount': '50%'
          }
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to add item');
        return response.json();
      })
      .then(data => resolve(data))
      .catch(error => reject(error));
    });
  }
  
  // Helper function to get selected variant ID
  function getSelectedVariantId(productElement) {
    try {
      const variants = JSON.parse(productElement.dataset.variants);
      const selects = productElement.querySelectorAll('.bundle-variant-selector');
      const selectedOptions = Array.from(selects).map(select => select.value);
      
      // Find variant that matches all selected options
      const matchedVariant = variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
      
      return matchedVariant ? matchedVariant.id : null;
    } catch (e) {
      console.error('Error getting variant ID:', e);
      return null;
    }
  }
  
  // Update UI based on bundle state
  function updateBundleUI() {
    // Update progress bar
    const progress = (bundleItems.length / 4) * 100;
    document.querySelector('.progress-bar').style.width = `${progress}%`;
    
    // Update counter
    document.querySelector('.bundle-progress span').textContent = 
      `${bundleItems.length}/4 products selected`;
    
    // Update add bundle button
    if (bundleItems.length === 4) {
      addBundleBtn.disabled = false;
      addBundleBtn.classList.add('enabled');
    } else {
      addBundleBtn.disabled = true;
      addBundleBtn.classList.remove('enabled');
    }
    
    // Update all add buttons
    document.querySelectorAll('.bundle-add-btn').forEach(button => {
      const productId = button.dataset.productId;
      const isInBundle = bundleItems.some(item => item.id === productId);
      
      button.disabled = !isInBundle && bundleItems.length >= 4;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
